import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges, output, inject, input } from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { DatePickerModule } from 'primeng/datepicker';

import { SelectModule } from 'primeng/select';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AppErrors, NotFoundError } from '@fitness-force/models';
import { ErrorMsgComponent,ErrorsComponent} from '@fitness-force/errors';;

import type {
  Client,
  Country,
  CreateOpportunityRequest,
  GetStaffListResponse,
  ListOpportunityStageMasterResponse,
  ListServiceTypeResponse,
  OpportunityResponse,
  OpportunityStageMasterResponse,
  PagedResults,
  PaginationFilter,
  ServiceTypeResponse,
  STAFFINTERFACE,
  TENANTSINTERFACE,
  UpdateOpportunityRequest,
} from '@fitness-force/models';
import { ActivatedRoute, Router } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { Store } from '@ngrx/store';

import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';

import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { OpportunityBoardType, Status } from '@fitness-force/enum';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import {
  COMPANY_INFO,
  COUNTRY_MASTER_STATE,
  STAGE_MASTER_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { DatePipe, AsyncPipe } from '@angular/common';

import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { MiniSearchComponent,} from '@fitness-force/common/search';
import {
  AuthSevices,
  CommonService,
  OpportunityStageService,
  ToastMessageService,
  UserService, ServiceTypeService,OpportunityService
} from '@fitness-force/api';


import { DividerModule } from 'primeng/divider';
// import { TextTransFormPipeModule } from '../../../filters/text-transform.pipe';
import { AvatarModule } from 'primeng/avatar';
import { ChipModule } from 'primeng/chip';
import { InputNumberComponent } from '@fitness-force/common-input-number';


@Component({
  selector: 'create-opportunity',
  templateUrl: './create-opportunity.component.html',
  styleUrls: ['./create-opportunity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService, DatePipe],
  standalone: true,
  imports: [
    StyleClassModule,
    DialogModule,
    FormsModule,
    DatePickerModule,
    ReactiveFormsModule,
    SelectModule,
    MultiSelectModule,
    SelectButtonModule,
    InputNumberModule,
    InputMaskModule,
    ToggleSwitchModule,
    ButtonModule,
    InputTextModule,
    ErrorMsgComponent,
    AssignedToComponent,
    ErrorsComponent,
    MiniSearchComponent,
    DividerModule,
    AvatarModule,
    ChipModule,
    InputNumberComponent,
    TranslateModule,
    AsyncPipe,
    InputGroupModule,
    InputGroupAddonModule
]
})
export class CreateOpportunityComponent implements OnInit, OnChanges {
  private  readonly fb = inject(UntypedFormBuilder);
  translate = inject(TranslateService);
  private  readonly router = inject(Router);
  private  readonly actRoute = inject(ActivatedRoute);
  private  readonly userService = inject(UserService);
  store = inject(Store);
  private  readonly serviceType = inject(ServiceTypeService);
  private  readonly opportunityService = inject(OpportunityService);
  private  readonly opportunityStageService = inject(OpportunityStageService);
  private  readonly toastMessageService = inject(ToastMessageService);
  authService = inject(AuthSevices);
  changeDetectorRef = inject(ChangeDetectorRef);
  datepipe = inject(DatePipe);
  private  readonly commonService = inject(CommonService);

  frmgroupCreateOpportunity: UntypedFormGroup = new UntypedFormGroup({});

  //used for popup close and open
  readonly showPopup = input(false, { alias: "visible" });
  readonly oOpportunity = input<OpportunityResponse | any>(undefined, { alias: "opportunity" });
  readonly clientInfo = input<any[]>([]);

  readonly hidePopup = output<any>();

  public showMiniSearch = false;
  public clients: any = [];

  errMsg: Error | any;
  tenantId = 0;
  clientId = 0;
  alreadyOpportunity: any = null;

  //#region Variables
  convertibility: Convertibility[] = CONSTANTS_CRM.OPPORTUNITY_CONVERTITBILITY;
  serviceTypeCollection!: Option[];
  assignedCollection!: Option[];
  opportunityStageCollection!: Option[];

  interestedInSelectedTitle = '';
  titleValueChanged = false;

  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  stageMaster$: Observable<any> = new Subject();

  _isEditMode = false;
  _selectedstaff = new BehaviorSubject<number>(0);
  country!: Country;

  isClientEditMode = false;

  //#endregion

  public companyInfoDetail$!: Observable<any>;
  companyDetails: any;
  isFormSubmitting = false;
  showCreateProspectPopup$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  error = new BehaviorSubject(null as AppErrors | null);

  constructor() {
    this.componentInit();
    this.SetFormFields();
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }

  ngOnInit(): void {
    const oOpportunity = this.oOpportunity();
    if (oOpportunity) {
      this.setOpportunityData(oOpportunity);
      this._isEditMode = true;
    }

    this.setVariable();
    this._selectedstaff.next(Number(this.authService.loggedInStaffId));
    this.store.select(COUNTRY_MASTER_STATE).subscribe((country: Country) => {
      this.country = country;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes?.clientInfo?.currentValue?.length
    ) {
      this.clients = changes.clientInfo.currentValue;
    }


    if (changes?.oOpportunity?.currentValue) {
      this.clients = [changes.oOpportunity.currentValue.client_info];
      this.setOpportunityData(this.oOpportunity());
      this._isEditMode = true;
    }

  }

  get clientIds(): number[] {
    return this.clientInfo()?.map((o: any) => {
      return o.id;
    });
  }

  SetFormFields(): void {
    this.frmgroupCreateOpportunity = this.fb.group({
      ddlConvertibility: new UntypedFormControl('', [Validators.required]),
      ddlOpportunityStage: new UntypedFormControl('', [Validators.required]),
      serviceType: new UntypedFormControl('', [Validators.required]),
      expectedamount: new UntypedFormControl('', []),
      expecteddate: new UntypedFormControl('', []),
      title: new UntypedFormControl('', [Validators.required]),
      comments: new UntypedFormControl('', []),
      ddlSelectedAssigned: new UntypedFormControl('', [Validators.required]),
      referred_by: new UntypedFormControl('', []),
    });

  }

  componentInit() {
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      this.companyDetails = responseData;
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.stageMaster$ = this.store.select(STAGE_MASTER_STATE);
  }

  setVariable() {
    this.showMiniSearch = this.clients.length == 0;
    //this.BindUsers();
    this.BindServiceType();
    this.BindOpportunityStageMaster();
  }



  // #region  "Request Response functions"

  BindUsers(): void {
    const paginationFilter: PaginationFilter = {
      page_number: 1,
      page_size: 9999999,
    };

    this.userService.getStaffList(paginationFilter, 0).subscribe({
      next: (response: PagedResults<GetStaffListResponse>) => {
        this.assignedCollection = [];
        this.assignedCollection.push({ name: 'Select', value: 0 });
        response.items.forEach((getStaffListResponse: GetStaffListResponse) => {
          this.assignedCollection.push({
            name: getStaffListResponse.name,
            value: getStaffListResponse.id,
          });
        });
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
          this.errMsg = error.originalError.message;
        } else {
          alert('something went wrong');
        }
      },
    });
  }

  BindServiceType(): void {
    this.serviceType.GetServiceType(this.tenantId).subscribe({
      next: (serviceTypes: ListServiceTypeResponse) => {
        this.serviceTypeCollection = [];
        if (serviceTypes.items) {
          serviceTypes.items.forEach((serviceType: ServiceTypeResponse) => {
            const status = serviceType.status.toString();
            const varStatus: string = Status[Status.Active];
            const oOpportunity = this.oOpportunity();
            if (oOpportunity) {
              if (status === varStatus || oOpportunity.service_type_id) {
                this.serviceTypeCollection.push({
                  name: serviceType.name_primary_language,
                  value: serviceType.id,
                });
              }
            } else {
              if (status === varStatus) {
                this.serviceTypeCollection.push({
                  name: serviceType.name_primary_language,
                  value: serviceType.id,
                });
              }
            }
          });
        }

        const oOpportunity = this.oOpportunity();
        if (oOpportunity) {
          const data: Option[] = [];
          for (const iCtr in oOpportunity.service_type) {
            const oData = this.serviceTypeCollection.find(
              (x) => x.value == this.oOpportunity().service_type[iCtr].id
            );
            if (oData) data.push(oData);
          }
          this.ServiceType.setValue(data);
        }
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
          this.errMsg = error.originalError.message;
        } else {
          alert('something went wrong');
        }
      },
    });
  }

  BindOpportunityStageMaster(): void {
    this.opportunityStageService
      .OpportunityStageMasterListService(
        this.tenantId,
        OpportunityBoardType.NewMemberBoard
      )
      .subscribe({
        next: (listOpportunityStage: ListOpportunityStageMasterResponse) => {
          this.opportunityStageCollection = [] as Option[];
          listOpportunityStage.items.forEach(
            (opportunityStage: OpportunityStageMasterResponse) => {
              this.opportunityStageCollection.push({
                name: opportunityStage.name_primary_language,
                value: opportunityStage.id,
              });
            }
          );
          if (this.oOpportunity()) {
            const oData = this.opportunityStageCollection.find(
              (x) => x.value == this.oOpportunity().stage_master_id
            );
            this.SelectedOpportnityStage.setValue(oData);
          }
        },
        error: (error) => {
          if (error instanceof NotFoundError) {
            this.errMsg = error.originalError.message;
          } else {
            alert('something went wrong');
          }
        },
      });
  }

  SaveData(): void {
    if (this._isEditMode) {
      this.UpdateOpportunity();
    } else {
      this.CreateOpportunity();
    }
  }

  UpdateOpportunity(): void {
    this.frmgroupCreateOpportunity.markAllAsTouched();

    if (!this.frmgroupCreateOpportunity.valid) {
      return;
    }
    const updateOpportunity: UpdateOpportunityRequest =
      {} as UpdateOpportunityRequest;
    updateOpportunity.comments = this.Comments.value;

    if (
      this.ExpectedAmount.value == undefined ||
      this.ExpectedAmount.value == ''
    )
      updateOpportunity.value_in_minor_currency = 0;
    else
      updateOpportunity.value_in_minor_currency =
        this.commonService.ConvertMinorCurrencyFromAmount(
          this.ExpectedAmount.value
        );

    if (
      this.ExpectedClosureDate.value == undefined ||
      this.ExpectedClosureDate.value == ''
    )
      updateOpportunity.expected_closure_date = undefined;
    else
      updateOpportunity.expected_closure_date = this.ExpectedClosureDate.value;

    updateOpportunity.name = this.SelectedTitle.value;
    updateOpportunity.hot_warm_cold = this.SelectedConvertibility.value.value;
    updateOpportunity.service_type_ids = Array.prototype.map.call(
      this.ServiceType.value,
      function (item) {
        return item.value;
      }
    ) as number[];
    updateOpportunity.stage_master_id =
      this.SelectedOpportnityStage.value.value;
    updateOpportunity.assigned_to_staff_id = this.SelectedAssigned.value.id;
    this.isFormSubmitting = true;
    this.opportunityService
      .OpportunityUpdateService(
        this.tenantId,
        OpportunityBoardType.NewMemberBoard,
        this.oOpportunity().id,
        updateOpportunity
      )
      .subscribe({
        next: async (data: any) => {
          this.isFormSubmitting = false;
          if (data || data?.id) {

            this.translate
              .get('OPPORTUNITY.UPDATE.OPPORTUNITY_CREATE_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });

            this.setHidePopup(true);
          } else {
            this.errorMessages.push(data.info);
            this.showErrorPopup?.next(true);
          }
        },
        error: (error: AppErrors) => {
          this.isFormSubmitting = false;

          if (error instanceof NotFoundError) {
            this.errorMessages.push(error.originalError.error.errorMessage);
            this.showErrorPopup?.next(true);
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error);
              this.showErrorPopup?.next(true);
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.showErrorPopup?.next(true);
            }
          }
        },
      });
  }

  CreateOpportunity(): void {
    this.frmgroupCreateOpportunity.markAllAsTouched();
    if (!this.frmgroupCreateOpportunity.valid) {
      const firstElementWithError: Element | null =
        document.querySelector('.ng-invalid');
      if (firstElementWithError)
        firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    const createOpportunity: CreateOpportunityRequest = {} as CreateOpportunityRequest;
    createOpportunity.client_id = this.clients?.clt_id
      ? [this.clients?.clt_id]
      : this.clientInfo().map((value) => value.id); // [this.clients?.clt_id || this.clientInfo[0]?.id]; //[this.clients[0]?.clt_id || this.clientInfo[0]?.id];
    createOpportunity.comments = this.Comments.value;

    if (this.ExpectedAmount.value)
      createOpportunity.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(this.ExpectedAmount.value);
    else createOpportunity.value_in_minor_currency = 0;

    if (this.ExpectedClosureDate.value == undefined || this.ExpectedClosureDate.value == '')
      createOpportunity.expected_closure_date = undefined;
    else
      createOpportunity.expected_closure_date = this.ExpectedClosureDate.value;

    createOpportunity.name = this.SelectedTitle.value;
    createOpportunity.hot_warm_cold = this.SelectedConvertibility.value.value;
    createOpportunity.service_type_ids = Array.prototype.map.call(this.ServiceType.value, function (item) { return item.value; }) as number[];
    createOpportunity.stage_master_id = this.SelectedOpportnityStage.value.value;
    createOpportunity.assigned_to_staff_id = this.SelectedAssigned.value.id;
    //createOpportunity.referred_by = this.ReferredByFormControl.value ? this.ReferredByFormControl.value : 0;
    this.isFormSubmitting = true;
    this.opportunityService
      .OpportunityCreateService(
        this.tenantId,
        OpportunityBoardType.NewMemberBoard,
        createOpportunity
      )
      .subscribe({
        next: async (data: any) => {
          this.isFormSubmitting = false;
          if (parseInt(data) > 0) {

            this.translate
              .get('OPPORTUNITY.CREATE.OPPORTUNITY_CREATE_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
                this.setHidePopup(true);
              });

            await this.timeout(1000);
            this.setHidePopup();
          } else {
            this.errorMessages.push(data.info);
            this.showErrorPopup?.next(true);
          }
        },
        error: (error: AppErrors) => {
          this.isFormSubmitting = false;
          this.errorMessages = [];
          if (error instanceof NotFoundError) {
            this.errorMessages.push(error.originalError.error.errorMessage);
            this.showErrorPopup?.next(true);
          } else if (
            error.originalError?.error?.[0]
          ) {
            const currentError = error.originalError.error[0];
            if (currentError.errorCode == 'duplicatevalue') {
              this.toastMessageService.showErrorMessage(currentError);
              return;
            }
          }
          {
            this.error.next(error);
            this.showErrorPopup?.next(true);
          }
        },
      });
  }

  //#region utility functions
  setHidePopup(modified = false) {
    this._isEditMode = false;
    this.frmgroupCreateOpportunity.reset();
    this.hidePopup.emit({ showPopup: false, modified });
    this.titleValueChanged = false;
  }

  closeDialog() {
    this.setHidePopup();
  }

  setOpportunityData(opportunity: OpportunityResponse) {
    const d = new Date(opportunity.expected_closure_date);
    this.SelectedTitle.setValue(opportunity.name);
    this.ExpectedClosureDate.patchValue(d);
    this.ExpectedAmount.setValue(
      this.commonService.ConvertAmountFromMinorCurrency(
        opportunity.value_in_minor_currency
      )
    );
    this.Comments.setValue(opportunity.comments);
    if (opportunity.hot_warm_cold) {
      const data = this.convertibility.find(
        (x) => x.name == opportunity.hot_warm_cold.toString()
      );
      this.SelectedConvertibility.setValue(data);
    }
  }

  onChangeServiceTypeCollection(event: any) {
    const data = Array.prototype.map
      .call(event.value, function (item) {
        return item.name;
      })
      .join(', ')
      .replace(/, ([^,]*)$/, ' and $1');

    if (!this.titleValueChanged) this.interestedInSelectedTitle = data;
    this.frmgroupCreateOpportunity.controls.title.setValue(data);
  }

  public selectedStaff(e: STAFFINTERFACE[]) {
    this.frmgroupCreateOpportunity.controls.ddlSelectedAssigned.setValue(e);
  }

  //#region "Omni Search"
  setClient(e: any) {
    if (this.frmgroupCreateOpportunity.disabled) {
      this.frmgroupCreateOpportunity.enable();
    }
    this.alreadyOpportunity = null;
    this.clients = null;
    this.clients = e;

    if (!(this.clients instanceof Array) || (this.clients instanceof Array && this.clients.length === 1)) {
      this.getOpportunities()
    }
  };

  removedClient() {
    this.alreadyOpportunity = null;
    if (this.frmgroupCreateOpportunity.disabled) {
      this.frmgroupCreateOpportunity.enable();
    }
  }

  getOpportunities() {
    if (!(this.clients instanceof Array) || (this.clients instanceof Array && this.clients.length === 1)) {
      let client = this.clients;
      if (this.clients.length === 1) {
        client = this.clients[0];
      }
      this.opportunityService
        .getOpportunityService(
          this.tenantId,
          OpportunityBoardType.NewMemberBoard
        ).subscribe((opportunities: any) => {
          if (opportunities && opportunities.length > 0) {
            this.alreadyOpportunity = opportunities.find((opportunity: any) => {
              return opportunity?.client_info.id === client?.clt_id
            });
            if (this.alreadyOpportunity)
              this.frmgroupCreateOpportunity.disable();
          }
        })
    }
  }

  createProspect(event: any) {
    this.showCreateProspectPopup$.next(true);
  }

  hideClientPopup(clientId: number) {
    this.showCreateProspectPopup$.next(false);
  }

  GetClientReferrel(client: Client) {
    this.ReferredByFormControl.setValue(client.clt_id);
  }

  removeClient(event: any) {
    this.ReferredByFormControl.setValue(0);
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // #region "getter"

  get SelectedOpportnityStage() { return this.frmgroupCreateOpportunity.controls.ddlOpportunityStage as UntypedFormControl; }
  get SelectedConvertibility() { return this.frmgroupCreateOpportunity.controls.ddlConvertibility as UntypedFormControl; }
  get SelectedAssigned(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.ddlSelectedAssigned as UntypedFormControl; }
  get ExpectedClosureDate(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.expecteddate as UntypedFormControl; }
  get ExpectedAmount(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.expectedamount as UntypedFormControl; }
  get SelectedTitle(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.title as UntypedFormControl; }
  get Comments(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.comments as UntypedFormControl; }
  get ServiceType(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.serviceType as UntypedFormControl; }
  get ReferredByFormControl(): UntypedFormControl { return this.frmgroupCreateOpportunity.controls.referred_by as UntypedFormControl; }

}

interface Option {
  name: string;
  value: number;
}

interface Convertibility {
  name: string;
  value: string;
  icon: string;
}
